/* Wishlist – heart buttons, header icon and wishlist tab inside the cart drawer.
   Storage: localStorage (per browser). Product data is loaded from /products/<handle>.js */
(function () {
  'use strict';

  if (window.__bfWishlist) return;
  window.__bfWishlist = true;

  var STORAGE_KEY = 'bluefire:wishlist:v1';

  var STRINGS = {
    de: {
      add: 'Zur Wunschliste hinzufügen',
      remove: 'Von der Wunschliste entfernen',
      removeItem: 'Entfernen',
      wishlist: 'Wunschliste',
      emptyTitle: 'Deine Wunschliste ist leer',
      emptyText: 'Tippe bei einem Produkt auf das Herz, um es hier zu speichern.',
      continueShopping: 'Weiter einkaufen',
      addToBag: 'In den Warenkorb',
      selectSize: 'Größe wählen',
      soldOut: 'Ausverkauft',
      addError: 'Der Artikel konnte nicht hinzugefügt werden.',
      count: function (n) { return n === 1 ? '1 Artikel' : n + ' Artikel'; }
    },
    en: {
      add: 'Add to wishlist',
      remove: 'Remove from wishlist',
      removeItem: 'Remove',
      wishlist: 'Wishlist',
      emptyTitle: 'Your wishlist is empty',
      emptyText: 'Tap the heart on any product to save it here.',
      continueShopping: 'Continue shopping',
      addToBag: 'Add to bag',
      selectSize: 'Select a size',
      soldOut: 'Sold out',
      addError: 'This item could not be added.',
      count: function (n) { return n === 1 ? '1 item' : n + ' items'; }
    }
  };

  var htmlLang = (document.documentElement.lang || 'en').toLowerCase();
  var t = STRINGS[htmlLang.slice(0, 2)] || STRINGS.en;
  var shopify = window.Shopify || {};
  var root = (shopify.routes && shopify.routes.root) || '/';
  var currency = (shopify.currency && shopify.currency.active) || 'EUR';

  var HEART_HTML =
    '<span class="wishlist-heart" aria-hidden="true">' +
    '<svg class="wishlist-heart--outline" viewBox="0 0 24 24" focusable="false"><path d="M16.5 3c-1.74 0-3.41.81-4.5 2.09C10.91 3.81 9.24 3 7.5 3 4.42 3 2 5.42 2 8.5c0 3.78 3.4 6.86 8.55 11.54L12 21.35l1.45-1.32C18.6 15.36 22 12.28 22 8.5 22 5.42 19.58 3 16.5 3zm-4.4 15.55-.1.1-.1-.1C7.14 14.24 4 11.39 4 8.5 4 6.5 5.5 5 7.5 5c1.54 0 3.04.99 3.57 2.36h1.87C13.46 5.99 14.96 5 16.5 5c2 0 3.5 1.5 3.5 3.5 0 2.89-3.14 5.74-7.9 10.05z"/></svg>' +
    '<svg class="wishlist-heart--fill" viewBox="0 0 24 24" focusable="false"><path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"/></svg>' +
    '</span>';

  var PROXY = '/apps/wishlist';
  var OWNER_KEY = 'bluefire:wishlist:owner';
  var SYNC_OFF_KEY = 'bluefire:wishlist:sync-off';

  var items = readStorage();
  var products = {};
  var renderToken = 0;
  var openingWishlist = false;
  var frame = 0;

  /* ---------- storage ---------- */

  function readStorage() {
    try {
      var value = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
      return Array.isArray(value) ? value.filter(function (i) { return i && i.handle; }) : [];
    } catch (e) {
      return [];
    }
  }

  function writeStorage() {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
    } catch (e) { /* storage unavailable – keep in-memory state */ }
  }

  function has(handle) {
    return items.some(function (i) { return i.handle === handle; });
  }

  function toggle(handle) {
    var added = !has(handle);
    if (added) {
      items.unshift({ handle: handle, addedAt: Date.now() });
    } else {
      items = items.filter(function (i) { return i.handle !== handle; });
    }
    writeStorage();
    changed();
    track(added ? 'add_to_wishlist' : 'remove_from_wishlist', handle);
    return added;
  }

  /* Analytics: GA4 ecommerce events through the GTM dataLayer + Shopify customer events */
  function track(eventName, handle) {
    loadProduct(handle).then(function (product) {
      if (!product) return;
      var value = product.price / 100;
      var ecommerce = {
        currency: currency,
        value: value,
        items: [{
          item_id: String(product.id),
          item_name: product.title,
          item_brand: product.vendor,
          item_category: product.type,
          price: value,
          quantity: 1
        }]
      };

      /* counters in the shop admin + persistence for signed-in customers */
      api('/event', { event: eventName, productId: product.id });

      if (window.dataLayer) {
        window.dataLayer.push({ ecommerce: null });
        window.dataLayer.push({ event: eventName, ecommerce: ecommerce, wishlist_handle: handle, wishlist_size: items.length });
      }

      var analytics = window.Shopify && window.Shopify.analytics;
      if (analytics && typeof analytics.publish === 'function') {
        try {
          analytics.publish(eventName, {
            handle: handle,
            productId: product.id,
            title: product.title,
            price: value,
            currency: currency,
            wishlistSize: items.length
          });
        } catch (e) { /* analytics must never break the storefront */ }
      }
    });
  }

  function changed() {
    syncButtons();
    updateCounts();
    renderPanel();
    window.dispatchEvent(new CustomEvent('wishlist:updated', { detail: { handles: items.map(function (i) { return i.handle; }) } }));
  }

  /* ---------- account sync (wishlist app behind the Shopify app proxy) ---------- */

  function isLoggedIn() {
    return !!document.body && document.body.getAttribute('data-logged-in') === 'true';
  }

  function readOwner() {
    try { return localStorage.getItem(OWNER_KEY) || ''; } catch (e) { return ''; }
  }

  function writeOwner(id) {
    try {
      if (id) localStorage.setItem(OWNER_KEY, id);
      else localStorage.removeItem(OWNER_KEY);
    } catch (e) { /* ignore */ }
  }

  function syncDisabled() {
    try { return sessionStorage.getItem(SYNC_OFF_KEY) === '1'; } catch (e) { return false; }
  }

  /* Resolves to parsed JSON, or null when the app is unreachable. Stops trying for the session if it isn't installed. */
  function api(path, body) {
    if (syncDisabled()) return Promise.resolve(null);
    return fetch(PROXY + path, {
      method: body ? 'POST' : 'GET',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: body ? JSON.stringify(body) : undefined,
      credentials: 'same-origin',
      keepalive: !!body
    })
      .then(function (r) {
        var type = r.headers.get('content-type') || '';
        if (r.status === 404 || type.indexOf('application/json') === -1) {
          try { sessionStorage.setItem(SYNC_OFF_KEY, '1'); } catch (e) { /* ignore */ }
          return null;
        }
        return r.ok ? r.json() : null;
      })
      .catch(function () { return null; });
  }

  /* Signed-in customers: the account list is the source of truth. A guest list is merged in once, on first login. */
  function syncAccount() {
    if (!isLoggedIn()) {
      if (readOwner()) {
        /* signed out: don't leave the previous customer's list on a shared device */
        writeOwner('');
        items = [];
        writeStorage();
        changed();
      }
      return;
    }

    api('/list').then(function (account) {
      if (!account || !account.loggedIn) return null;

      var guestItems = readOwner() ? [] : items.slice();
      var known = account.items.map(function (p) { return p.handle; });
      var missing = guestItems.filter(function (i) { return known.indexOf(i.handle) === -1; });

      return Promise.all(missing.map(function (i) { return loadProduct(i.handle); })).then(function (found) {
        var ids = found.filter(Boolean).map(function (p) { return p.id; });
        if (!ids.length) return account;
        return api('/sync', { productIds: ids }).then(function (merged) {
          if (merged && merged.loggedIn) return merged;
          return { loggedIn: true, customerId: account.customerId, items: account.items, unsynced: missing };
        });
      });
    }).then(function (result) {
      if (!result) return;
      var handles = result.items.map(function (p) { return p.handle; });
      var keep = (result.unsynced || []).filter(function (i) { return handles.indexOf(i.handle) === -1; });
      items = result.items.map(function (p) { return { handle: p.handle, addedAt: Date.now() }; }).concat(keep);
      writeOwner(String(result.customerId));
      writeStorage();
      changed();
    });
  }

  /* ---------- helpers ---------- */

  function esc(value) {
    return String(value == null ? '' : value).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function money(cents) {
    try {
      return new Intl.NumberFormat(htmlLang, { style: 'currency', currency: currency }).format(cents / 100);
    } catch (e) {
      return (cents / 100).toFixed(2) + ' ' + currency;
    }
  }

  function sized(src, width) {
    return src + (src.indexOf('?') === -1 ? '?' : '&') + 'width=' + width;
  }

  function loadProduct(handle) {
    if (!products[handle]) {
      products[handle] = fetch(root + 'products/' + encodeURIComponent(handle) + '.js', { headers: { Accept: 'application/json' } })
        .then(function (r) {
          if (r.status === 404) return null;
          if (!r.ok) throw new Error(String(r.status));
          return r.json();
        })
        .catch(function () {
          delete products[handle];
          return undefined;
        });
    }
    return products[handle];
  }

  /* ---------- buttons & counters ---------- */

  function syncButtons() {
    document.querySelectorAll('[data-wishlist-toggle]').forEach(function (button) {
      var active = has(button.getAttribute('data-handle'));
      button.setAttribute('aria-pressed', active ? 'true' : 'false');
      button.setAttribute('aria-label', active ? t.remove : t.add);
    });
  }

  function updateCounts() {
    var count = items.length;
    document.querySelectorAll('[data-wishlist-count]').forEach(function (el) {
      el.setAttribute('data-wishlist-count', count);
    });
    document.querySelectorAll('[data-wishlist-tab-count]').forEach(function (el) {
      el.textContent = count;
      el.hidden = count === 0;
    });
    document.querySelectorAll('[data-wishlist-open]').forEach(function (el) {
      el.setAttribute('aria-label', t.wishlist);
    });
    document.querySelectorAll('[data-wishlist-title]').forEach(function (el) {
      el.textContent = t.wishlist;
    });
    document.querySelectorAll('[data-wishlist-tab="wishlist"]').forEach(function (el) {
      el.setAttribute('aria-label', t.wishlist);
    });
  }

  /* Hearts next to every cart line (the cart is re-rendered by the theme, so decorate on change) */
  function decorateCart() {
    document.querySelectorAll('.cart--item').forEach(function (line) {
      if (line.querySelector('[data-wishlist-toggle]')) return;
      var link = line.querySelector('a[href*="/products/"]');
      var match = link && link.getAttribute('href').match(/\/products\/([^/?#]+)/);
      if (!match) return;
      var button = document.createElement('button');
      button.type = 'button';
      button.className = 'wishlist-btn wishlist-btn--cart';
      button.setAttribute('data-wishlist-toggle', '');
      button.setAttribute('data-handle', decodeURIComponent(match[1]));
      button.setAttribute('aria-pressed', 'false');
      button.innerHTML = HEART_HTML;
      line.appendChild(button);
    });
  }

  /* ---------- drawer tab ---------- */

  function setTab(tab) {
    document.querySelectorAll('.drawer--container[data-view="cart-drawer"]').forEach(function (container) {
      container.setAttribute('data-wl-tab', tab);
    });
    document.querySelectorAll('[data-wishlist-tab]').forEach(function (button) {
      button.setAttribute('aria-pressed', button.getAttribute('data-wishlist-tab') === tab ? 'true' : 'false');
    });
    if (tab === 'wishlist') {
      renderPanel();
      document.querySelectorAll('[data-wishlist-panel]').forEach(function (panel) { panel.scrollTop = 0; });
    }
  }

  function openWishlist(trigger) {
    openingWishlist = true;
    setTab('wishlist');
    window.dispatchEvent(new CustomEvent('theme:drawer:open', {
      detail: { side: 'right', view: 'cart-drawer', trigger: trigger || null }
    }));
    openingWishlist = false;
  }

  /* ---------- panel ---------- */

  function emptyHtml() {
    return '<div class="wishlist-empty">' +
      '<div class="wishlist-empty--icon">' + HEART_HTML + '</div>' +
      '<p class="wishlist-empty--title">' + esc(t.emptyTitle) + '</p>' +
      '<p class="wishlist-empty--text">' + esc(t.emptyText) + '</p>' +
      '<a class="wishlist-empty--link" href="' + esc(root + 'collections/all') + '">' + esc(t.continueShopping) + '</a>' +
      '</div>';
  }

  function itemHtml(product) {
    var variants = product.variants || [];
    var available = variants.filter(function (v) { return v.available; });
    var url = root + 'products/' + product.handle;
    var image = product.featured_image
      ? '<img src="' + esc(sized(product.featured_image, 240)) + '" alt="' + esc(product.title) + '" loading="lazy" width="120" height="160">'
      : '';
    var onSale = product.compare_at_price && product.compare_at_price > product.price;
    var price = (onSale ? '<s>' + money(product.compare_at_price) + '</s>' : '') +
      '<span' + (onSale ? ' class="wishlist-item--sale"' : '') + '>' + money(product.price) + '</span>';
    var action;

    if (!available.length) {
      action = '<button type="button" class="wishlist-item--add" disabled>' + esc(t.soldOut) + '</button>';
    } else if (variants.length === 1) {
      action = '<button type="button" class="wishlist-item--add" data-wishlist-add data-variant="' + available[0].id + '">' + esc(t.addToBag) + '</button>';
    } else {
      action = '<button type="button" class="wishlist-item--add" data-wishlist-add data-multi aria-expanded="false">' + esc(t.selectSize) + '</button>' +
        '<div class="wishlist-sizes" hidden>' +
        variants.map(function (v) {
          return '<button type="button" class="wishlist-size" data-wishlist-variant="' + v.id + '"' + (v.available ? '' : ' disabled') + '>' + esc(v.title) + '</button>';
        }).join('') +
        '</div>';
    }

    return '<article class="wishlist-item" data-handle="' + esc(product.handle) + '">' +
      '<a class="wishlist-item--image" href="' + esc(url) + '" tabindex="-1" aria-hidden="true">' + image + '</a>' +
      '<div class="wishlist-item--info">' +
      '<a class="wishlist-item--title" href="' + esc(url) + '">' + esc(product.title) + '</a>' +
      '<div class="wishlist-item--price">' + price + '</div>' +
      '<div class="wishlist-item--actions">' + action + '</div>' +
      '<p class="wishlist-item--error" role="alert" hidden></p>' +
      '<button type="button" class="wishlist-item--remove" data-wishlist-toggle data-handle="' + esc(product.handle) + '" aria-pressed="true">' + esc(t.removeItem) + '</button>' +
      '</div>' +
      '<button type="button" class="wishlist-btn wishlist-btn--item" data-wishlist-toggle data-handle="' + esc(product.handle) + '" aria-pressed="true">' + HEART_HTML + '</button>' +
      '</article>';
  }

  function renderPanel() {
    var panels = document.querySelectorAll('[data-wishlist-panel]');
    if (!panels.length) return;

    var token = ++renderToken;
    var snapshot = items.slice();

    if (!snapshot.length) {
      panels.forEach(function (panel) { panel.innerHTML = emptyHtml(); });
      return;
    }

    Promise.all(snapshot.map(function (i) { return loadProduct(i.handle); })).then(function (results) {
      if (token !== renderToken) return;

      var gone = [];
      var html = results.map(function (product, index) {
        if (product === null) gone.push(snapshot[index].handle);
        return product ? itemHtml(product) : '';
      }).join('');

      var shown = results.filter(Boolean).length;
      panels.forEach(function (panel) {
        panel.innerHTML = shown
          ? '<p class="wishlist-panel--count">' + esc(t.count(shown)) + '</p><div class="wishlist-list">' + html + '</div>'
          : emptyHtml();
      });
      syncButtons();

      if (gone.length) {
        items = items.filter(function (i) { return gone.indexOf(i.handle) === -1; });
        writeStorage();
        updateCounts();
      }
    });
  }

  function addToBag(variantId, button) {
    if (button.getAttribute('aria-busy') === 'true') return;
    var line = button.closest('.wishlist-item');
    var error = line && line.querySelector('.wishlist-item--error');
    if (error) error.hidden = true;
    button.setAttribute('aria-busy', 'true');

    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }], sections: 'cart-drawer' })
    })
      .then(function (r) {
        return r.json().then(function (data) { return { ok: r.ok, data: data }; });
      })
      .then(function (result) {
        if (!result.ok) throw new Error(result.data && (result.data.description || result.data.message));
        var html = result.data.sections && result.data.sections['cart-drawer'];
        if (html) {
          window.dispatchEvent(new CustomEvent('theme:cart:drawer:updateHtml', { detail: { section: html } }));
        }
        return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            var counter = document.querySelector('[data-cart-count]');
            if (counter) counter.setAttribute('data-cart-count', cart.item_count);
            var viewport = document.querySelector('.layout--viewport');
            if (viewport) viewport.setAttribute('data-cart-empty', cart.item_count === 0 ? 'true' : 'false');
          });
      })
      .then(function () {
        setTab('cart');
        if (button.closest('[data-wishlist-page]')) {
          window.dispatchEvent(new CustomEvent('theme:drawer:open', {
            detail: { side: 'right', view: 'cart-drawer', trigger: button }
          }));
        }
      })
      .catch(function (e) {
        if (error) {
          error.textContent = (e && e.message) || t.addError;
          error.hidden = false;
        }
      })
      .then(function () {
        button.removeAttribute('aria-busy');
      });
  }

  /* ---------- events ---------- */

  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!target || !target.closest) return;

    var heart = target.closest('[data-wishlist-toggle]');
    if (heart) {
      event.preventDefault();
      event.stopPropagation();
      var added = toggle(heart.getAttribute('data-handle'));
      if (added) {
        document.querySelectorAll('[data-wishlist-toggle][data-handle="' + heart.getAttribute('data-handle') + '"]').forEach(function (el) {
          el.classList.remove('is-popping');
          void el.offsetWidth;
          el.classList.add('is-popping');
        });
      }
      return;
    }

    var tab = target.closest('[data-wishlist-tab]');
    if (tab) {
      event.preventDefault();
      setTab(tab.getAttribute('data-wishlist-tab'));
      return;
    }

    var open = target.closest('[data-wishlist-open]');
    if (open) {
      event.preventDefault();
      openWishlist(open);
      return;
    }

    var add = target.closest('[data-wishlist-add]');
    if (add) {
      event.preventDefault();
      if (add.hasAttribute('data-multi')) {
        var sizes = add.parentElement.querySelector('.wishlist-sizes');
        var expanded = add.getAttribute('aria-expanded') === 'true';
        add.setAttribute('aria-expanded', expanded ? 'false' : 'true');
        if (sizes) sizes.hidden = expanded;
      } else {
        addToBag(add.getAttribute('data-variant'), add);
      }
      return;
    }

    var size = target.closest('[data-wishlist-variant]');
    if (size && !size.disabled) {
      event.preventDefault();
      addToBag(size.getAttribute('data-wishlist-variant'), size);
    }
  }, true);

  document.addEventListener('animationend', function (event) {
    if (event.target && event.target.closest) {
      var button = event.target.closest('.wishlist-btn');
      if (button) button.classList.remove('is-popping');
    }
  });

  window.addEventListener('theme:drawer:open', function (event) {
    if (openingWishlist) return;
    if (event.detail && event.detail.view === 'cart-drawer') setTab('cart');
  });

  window.addEventListener('theme:drawer:right:closed', function () {
    setTab('cart');
  });

  window.addEventListener('storage', function (event) {
    if (event.key !== STORAGE_KEY) return;
    items = readStorage();
    changed();
  });

  /* Pick up cards, cart lines and sections the theme renders after load */
  function refresh() {
    frame = 0;
    decorateCart();
    syncButtons();
  }

  new MutationObserver(function () {
    if (!frame) frame = requestAnimationFrame(refresh);
  }).observe(document.documentElement, { childList: true, subtree: true });

  function init() {
    decorateCart();
    syncButtons();
    updateCounts();
    setTab('cart');
    if (document.querySelector('[data-wishlist-page]')) renderPanel();
    syncAccount();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
